<template>
  <div id="report">
    <header-top :headerText="headerText"></header-top>
    <main class="report-main">
      <div class="tips">温馨提示：本页面报表，默认下载全部人员的相关信息，如需修改，请至预览页面按需筛选下载。</div>
      <div class="table-info">
      <el-table :data="peopleList">
        <el-table-column type="index" width="50" align="center"></el-table-column>
        <el-table-column label-class-name="tab-tit" label="报表名称" min-width="100" align="left">
          <template slot-scope="scope">
            <div class="name-worknum">
              <div>
                <span>{{ scope.row.title }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label-class-name="tab-tit" label="描述" min-width="100" align="left">
          <template slot-scope="scope">
            <div class="name-worknum">
              <div>
                <span>{{ scope.row.describe }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <div class="table-operation">
              <el-button @click.native.prevent="toDetails( scope.row)" type="text" >预览</el-button>
              <el-button
                @click.native.prevent="recallChange(scope.$index, scope.row)"
                type="text"
                
              >下载</el-button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img src="../../../../assets/image/loading.png" alt="loading" class="loading-ico" />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading&&!peopleList.length">列表为空</div>
        </template>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.pageIndex"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="query.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      </div>
    </main>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
// import { peopleList } from "@/http/api/employe";
export default {
  components: {
    headerTop
  },
  data() {
    return {
      headerText: "人事报表",
      changeForm: [{}],
      query: {
        limit: 30,
        pageIndex: 1,
        dateRange: "",
        type: ""
      },
      total:7,
      isLoading: false,
      userTypeFilters: [
        { text: "全部类型", value: "UserAdmin" },
        { text: "网站用户", value: "User" },
        { text: "后台用户", value: "Admin" }
      ],
      orgDic: [
        {
          value: "人事",
          label: "人事"
        },
        {
          value: "法务",
          label: "法务"
        },
        {
          value: "财务",
          label: "财务"
        },
        {
          value: "信息",
          label: "信息"
        }
      ],
      dutyTypes: [
        {
          value: "业务",
          label: "业务"
        },
        {
          value: "职能",
          label: "职能"
        }
      ],
      peopleList: [
        {
          title: "员工通讯录",
          describe: "员工的通讯方式，包括联系电话、微信号等"
        },
        {
          title: "员工居住地址",
          describe: "员工的居住地址、籍贯地址信息"
        },
        {
          title: "员工生日",
          describe: "员工的生日信息"
        },
        {
          title: "员工婚姻情况",
          describe: "员工的婚姻信息"
        },
        {
          title: "员工惩罚表",
          describe: "员工的惩罚信息"
        },
        {
          title: "员工学历",
          describe: "员工的学历信息"
        },
        {
          title: "员工入离调转汇总",
          describe: "员工的入职离职调转信息汇总"
        }
      ]
    };
  },
  mounted() {
    this.getpeopleList();
  },
  methods: {
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
    recallChange() {},
    toDetails(val) {
      if (val.title != "员工入离调转汇总") {
        this.$router.push({ path: `personnelDetails?name=${val.title}` });
      } else {
        this.$router.push({ path: `/hr/statisticalSummary` });
      }
    },
    getpeopleList() {
      //console.log("获取的时间筛选", this.time);
      if (this.time != "" && this.time != null) {
        this.query.start = this.time[0];
        this.query.end = this.time[1];
      } else {
        this.query.start = "";
        this.query.end = "";
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.report-main {
  padding: 20px;
  .tips {
    margin-bottom: 20px;
    padding: 0 20px;
    height: 48px;
    line-height: 48px;
    font-size: 12px;
    color: $--color-primary;
    background: #c1eea9;
  }
  .table-info{
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
  }
  .el-table {
    // min-height: calc( 100vh - 210px);
    
    font-size: 12px;
    background: #fff;
    .table-operation {
      display: flex;
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
  }
  .pagination {
    padding: 15px 10px;
  }
}
</style>